'use client';

import { use } from 'react';
import { AccordionSelect } from '@ghosts-inc/design-system/components';
import { ALIGN_ADORNMENT_TOP } from '@/components/accordion-select-styles';
import { areArraysEqual } from '@/lib/areArraysEqual';
import { StepContext } from './StepContext';

export const CategoriesStep = ({
  categoriesPromise,
  initialValues,
}: {
  categoriesPromise: Promise<{ [key: string]: string[] }>;
  initialValues: string[];
}): JSX.Element => {
  const categoryOptions = use(categoriesPromise);
  const { setIsDirty } = use(StepContext);

  return (
    <AccordionSelect
      label="What categories do you prefer?"
      placeholder="Make a selection"
      name="categories"
      variant="filled"
      defaultValue={initialValues || []}
      structuredOptions={categoryOptions}
      onChange={(selected) => {
        if (!areArraysEqual(selected, initialValues)) {
          setIsDirty(true);
        }
      }}
      sx={ALIGN_ADORNMENT_TOP}
    />
  );
};
